import SekurityGroupEditor from './sekurity-group-editor';

export default SekurityGroupEditor;